import { HttpError } from '@refinedev/core';

/**
 * Nestes status o backend manda uma mensagem já escrita para quem está na
 * tela, e é ela que diz o que fazer a seguir:
 *
 * - 403: "Você não tem permissão para realizar esta ação."
 * - 422: turma encerrada, CSV ilegível, CPF inválido para a CIN (GERE6-473)
 *
 * Os dois têm em comum que **tentar de novo não resolve**, que é justamente o
 * que uma mensagem genérica de erro interno manda fazer.
 */
const ACTIONABLE_STATUSES = new Set([403, 422]);

/**
 * Os demais status não têm texto acionável: em 500 e em erro de rede o
 * interceptor do `api.ts` preenche `message` com o texto do axios ("Request
 * failed with status code 500"), que não ajuda ninguém. Nesses casos vale o
 * `fallback` de quem chama.
 */
export const actionableErrorMessage = (
  error: HttpError | undefined,
  fallback: string
): string =>
  error?.statusCode &&
  ACTIONABLE_STATUSES.has(error.statusCode) &&
  error.message
    ? error.message
    : fallback;
